import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatErr } from "@/lib/api";

const EMPTY = { name: "", company: "", email: "", phone: "", vat_number: "", notes: "", status: "active" };
const FIELDS = [
  ["name", "Nome referente *"], ["company", "Azienda / studio"], ["email", "Email"], ["phone", "Telefono"], ["vat_number", "P. IVA / C.F."],
];

export const ClientFormDialog = ({ open, onOpenChange, client, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) setForm(client ? { ...EMPTY, ...client } : EMPTY);
  }, [open, client]);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return toast.error("Inserisci il nome del cliente");
    setBusy(true);
    try {
      const payload = Object.fromEntries(Object.keys(EMPTY).map((k) => [k, form[k] || ""]));
      const { data } = client ? await api.put(`/clients/${client.id}`, payload) : await api.post("/clients", payload);
      toast.success(client ? "Cliente aggiornato" : "Cliente creato");
      onSaved?.(data);
      onOpenChange(false);
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="client-form-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-normal">{client ? "Modifica cliente" : "Nuovo cliente"}</DialogTitle>
          <DialogDescription>Dati privati di gestione: non vengono mai mostrati nelle pagine pubbliche.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map(([k, label]) => (
            <div key={k} className={k === "name" ? "sm:col-span-2" : ""}>
              <Label className="text-xs">{label}</Label>
              <Input data-testid={`client-form-${k}`} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="mt-1.5" />
            </div>
          ))}
          <div className="sm:col-span-2">
            <Label className="text-xs">Note interne</Label>
            <Textarea data-testid="client-form-notes" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="mt-1.5" rows={3} />
          </div>
          <div className="sm:col-span-2 flex justify-end gap-2 pt-2">
            <Button type="button" variant="ghost" onClick={() => onOpenChange(false)}>Annulla</Button>
            <Button type="submit" disabled={busy} data-testid="client-form-submit">{busy ? "Salvataggio…" : "Salva cliente"}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
